/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from "react";
import { QueryProvider } from "@thd-nucleus/data-sources";

let VendorCollectionProductsImport;

/** ****************************
 * Vendor Collection Product *
 ***************************** */
export const VendorCollectionProductsLoad = () =>
  import(
    /*
    webpackPrefetch: true,
    webpackChunkName: "vendor-collection-products"
  */
    "./subcomponents/VendorCollectionProducts"
  ).then((module) => {
    const { VendorCollectionProducts } = module;

    VendorCollectionProductsImport = (props) => (
      <QueryProvider
        dataSource="searchNav"
        defaultVariables={props.qctx.defaultVariables.current}
        cacheKey="vendor-collection-products"
      >
        <VendorCollectionProducts {...props} />
      </QueryProvider>
    );
  });

export const VendorCollectionProducts = (props) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient || !VendorCollectionProductsImport) {
    return null;
  }

  return <VendorCollectionProductsImport {...props} />;
};
